var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 19,
    viewBox: "0 0 60 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.4499 6.1532C58.8585 6.1532 60.0005 5.01126 60.0005 3.6026C60.0005 2.19394 58.8585 1.052 57.4499 1.052C56.0412 1.052 54.8993 2.19394 54.8993 3.6026C54.8993 5.01126 56.0412 6.1532 57.4499 6.1532Z",
    fill: "#07969E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9135 10.2427H40.9346C41.0315 13.4713 43.0346 15.2791 45.8744 15.2791C48.1988 15.2791 49.781 13.891 50.2007 12.0184H53.7842C53.2676 16.1185 49.5872 18.3463 45.8744 18.3463C40.6118 18.3463 37.1573 15.3115 37.1573 9.43631C37.1573 4.01141 40.5473 0.653809 45.6806 0.653809C50.7806 0.653809 53.9135 4.36661 53.9135 8.95121V10.2427ZM40.9346 8.01491H50.0393C49.8458 5.33531 48.1346 3.72101 45.5195 3.72101C43.0655 3.72101 41.1293 5.17391 40.9346 8.01491Z",
    fill: "#07969E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8297 12.4057H23.7039C23.8329 14.3752 25.3497 15.4738 28.0302 15.4738C30.2256 15.4738 31.5816 14.6668 31.5816 13.3108C31.5816 12.3097 31.0005 11.761 29.2893 11.3737L25.092 10.4686C22.0572 9.85541 20.217 8.27381 20.217 5.75381C20.217 2.65421 23.0259 0.653809 27.4812 0.653809C32.3565 0.653809 35.2299 2.84921 35.2299 6.59381H31.4523C31.4523 4.68881 30.0318 3.52661 27.6105 3.52661C25.4151 3.52661 24.0912 4.33391 24.0912 5.65661C24.0912 6.56051 24.8661 7.27091 26.2545 7.59371L30.6453 8.53001C33.906 9.24041 35.4882 10.66 35.4882 13.1467C35.4882 16.4077 32.7117 18.3448 27.9978 18.3448C22.8645 18.3463 19.9587 16.2154 19.8297 12.4057Z",
    fill: "#07969E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2616 0.911133H17.2003V17.8287H13.2616V0.911133Z",
    fill: "#07969E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.068 7.52973C4.8105 2.68683 6.5217 0.911133 11.1708 0.911133V4.23663C5.9727 4.55943 4.0356 6.20613 3.9387 11.2749V17.8287H0V1.16943H3.81L3.939 7.52943L4.068 7.52973Z",
    fill: "#07969E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bb8deb966f345a4a8ac1643177defab2.svg";
export { ForwardRef as ReactComponent };